/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Bottom_Right_TitleInputs */

const en_position_bottom_right_title = /** @type {(inputs: Position_Bottom_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position: Bottom Right`)
};

const fr_position_bottom_right_title = /** @type {(inputs: Position_Bottom_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position : En Bas a Droite`)
};

const de_position_bottom_right_title = /** @type {(inputs: Position_Bottom_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position: Unten rechts`)
};

const it_position_bottom_right_title = /** @type {(inputs: Position_Bottom_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione: in basso a destra`)
};

const ru_position_bottom_right_title = /** @type {(inputs: Position_Bottom_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиция: Нижний правый угол`)
};

const es_position_bottom_right_title = /** @type {(inputs: Position_Bottom_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición: Abajo a la derecha`)
};

const zh_cn2_position_bottom_right_title = /** @type {(inputs: Position_Bottom_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置：右下角`)
};

const ja_position_bottom_right_title = /** @type {(inputs: Position_Bottom_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置: 右下`)
};

const hi_position_bottom_right_title = /** @type {(inputs: Position_Bottom_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति: नीचे दाएँ`)
};

const pt_pt2_position_bottom_right_title = /** @type {(inputs: Position_Bottom_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição: Inferior direita`)
};

/**
* | output |
* | --- |
* | "Position: Bottom Right" |
*
* @param {Position_Bottom_Right_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_bottom_right_title = /** @type {((inputs?: Position_Bottom_Right_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Bottom_Right_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_bottom_right_title(inputs)
	if (locale === "de") return de_position_bottom_right_title(inputs)
	if (locale === "it") return it_position_bottom_right_title(inputs)
	if (locale === "ru") return ru_position_bottom_right_title(inputs)
	if (locale === "es") return es_position_bottom_right_title(inputs)
	if (locale === "zh-CN") return zh_cn2_position_bottom_right_title(inputs)
	if (locale === "ja") return ja_position_bottom_right_title(inputs)
	if (locale === "hi") return hi_position_bottom_right_title(inputs)
	if (locale === "pt-PT") return pt_pt2_position_bottom_right_title(inputs)
	return en_position_bottom_right_title(inputs)
});